import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import * as Sentry from "@sentry/browser";
import configureStore from "core-integration/src/configureStore";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router";
import { initializeGtm } from "shared-utils/src/gtm";
import App from "./components/App";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { msalConfig } from "./utils/msalConfig";

if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: "https://ceadf7c6efa347b81c76390992ef90a5@o118622.ingest.us.sentry.io/4509610575593472",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserProfilingIntegration(),
      new Sentry.BrowserTracing(),
    ],
    ignoreErrors: [/gtag is not defined/],
    maxBreadcrumbs: 50,
    tracesSampleRate: 0.000002,
    profilesSampleRate: 0.000002,
  });
}

initializeGtm(import.meta.env.VITE_GTM_ID);

const container = document.getElementById("root")!;
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);

// Data router required for useBlocker (CreateSquad, MyTeam, etc.)
const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <Provider store={configureStore()}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </Provider>
    ),
  },
]);

root.render(<RouterProvider router={router} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
